import { useQuery } from '@tanstack/react-query';
import { fetchPublishedPage, type PublishedPageSlug } from '../api/dms-pages';

export const publishedPageKeys = {
  all: ['vto', 'published-page'] as const,
  bySlug: (slug: PublishedPageSlug) => [...publishedPageKeys.all, slug] as const,
};

export function usePublishedPage(slug: PublishedPageSlug) {
  return useQuery({
    queryKey: publishedPageKeys.bySlug(slug),
    queryFn: () => fetchPublishedPage(slug),
    staleTime: 60 * 1000,
  });
}
